import { useBreakpointValue } from "../../hooks/use-breakpoint-value";

export type DescriptionVariant = "tooltip" | "static";

export const useDescriptionVariant = () => {
  const descriptionVariant = useBreakpointValue<DescriptionVariant>("static", {
    lg: "tooltip",
  });

  return descriptionVariant;
};

export const descriptionVariantClassMap: Record<DescriptionVariant, string> = {
  tooltip: "text-white",
  static: "text-shale-200",
};
